import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { Form } from 'antd';

import { routeFileSelector } from '../../../../../../../utilz/i18n';
import FormTextArea from '../../../../../../components/Inputs/FormTextArea';
import SecondaryLabel from '../../../../../../components/Labels/SecondaryLabel';

const TMSNotesDetails = () => {
  const [form] = Form.useForm();
  const shipmentNote = Form.useWatch('shipmentNote', form);
  const { pathname: activeTab } = useLocation();
  const namespace = useMemo(() => routeFileSelector(activeTab), [activeTab]);
  const { t } = useTranslation([namespace, 'translation']);
  return (
    <Form name="notesForm" form={form}>
      <FormTextArea
        name="shipmentNote"
        placeholder={`${t('translation:getQuote.notesHere')}...`}
        editMode
        margin="mb-0"
        rows={10}
      />
      <SecondaryLabel className="f16">
        {2000 - (shipmentNote ? shipmentNote?.length : 0)} {t('translation:getQuote.characters')}
      </SecondaryLabel>
    </Form>
  );
};

export default TMSNotesDetails;
